<template>
  <EditorPopover ref="popover" @cancel="cancelEditing">

    <TabbedBox>
      <template v-slot:tablist>
        <Tab :first="true" tabid="tab-clip" ref="clipTab">
          <i class="far fa-cut"></i> Clip Tool
        </Tab>
        <Tab tabid="tab-cut">
          <i class="far fa-scalpel-path"></i> Straight Cut Tool
        </Tab>
      </template>

      <template v-slot:tabcontent>
        <TabPage :first="true" tabid="tab-clip">
          Line Length: {{formatDecimal(lineLength, 2)}}mm

          <EditorPopoverButtonList v-if="editingEnabled">
            <EditorPopoverButton title="Cancel" type="cancel" icon="fa-times" @click="cancelEditing" />
            <EditorPopoverButton title="Clip - Keep Inside" type="action" icon="fa-cut" @click="popoverActionButtonClick('clipInside')" :disabled="!cutAvailable" />
            <EditorPopoverButton title="Clip - Keep Outside" type="action" icon="fa-cut" @click="popoverActionButtonClick('clipOutside')" :disabled="!cutAvailable" />
            <EditorPopoverButton title="Seperate" type="action" icon="fa-cut" @click="popoverActionButtonClick('seperate')" :disabled="!cutAvailable" />
            <EditorPopoverButton title="Slice" type="action" icon="fa-plus-circle" @click="popoverActionButtonClick('slice')" :disabled="!cutAvailable" />
          </EditorPopoverButtonList>
        </TabPage>

        <TabPage tabid="tab-cut">
          <EditorPopoverButtonList v-if="editingEnabled">
            <EditorPopoverButton title="Cancel" type="cancel" icon="fa-times" @click="cancelEditing" />
            <EditorPopoverButton title="Keep Inside" type="action" icon="fa-scalpel-path" @click="popoverActionButtonClick('cutInside')" :disabled="!cutAvailable" />
            <EditorPopoverButton title="Keep Outside" type="action" icon="fa-scalpel-path" @click="popoverActionButtonClick('cutOutside')" :disabled="!cutAvailable" />
          </EditorPopoverButtonList>
        </TabPage>
      </template>
    </TabbedBox>  
    
  </EditorPopover>
</template>



<script>
import _ from 'lodash'
import Utils from '@/utils/utils'
import EditorPopover from '@glass-designer/components/editorPopover'
import EditorPopoverMixin from '@glass-designer/mixins/editorPopover'
import EditorPopoverDataRow from '@glass-designer/components/editorPopoverDataRow'
import EditorKeypad from '@glass-designer/components/editorKeypad'
import MathsUtils from '@/utils/mathsUtils'

import EditorPopoverButtonList from '@glass-designer/components/popover/editorPopoverButtonList'
import EditorPopoverButton from '@glass-designer/components/popover/editorPopoverButton'

import { LibraryItemShapeTypes } from '@glass-designer/types'

export default {
  name: 'EditorCutToolPopover',
  mixins: [EditorPopoverMixin],
  components: {
    EditorPopover,
    EditorPopoverDataRow,
    EditorPopoverButtonList,
    EditorPopoverButton
  },
  props: {
    editingEnabled: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      toolInfoText: '',
      name: '',
      lineLength: 0,
      cutAvailable: false
    }
  },
  computed: {
  },
  watch: {
    
  },
  created() {

  },
  methods: {
    setup(editor, options) {
      this.clearOptions()

      this.name = options.name || 'Datum Line'
      let cutData = options.cutData || {}
      this.lineLength = cutData.lineLength || 0
      this.cutAvailable = cutData.cutAvailable

      // Setup callbacks next tick so they don't get called when resetting values
      this.callbackContext = options.context
      this.updateCallback = options.updateCallback
      this.actionCallback = options.actionCallback
      this.applyCallback = options.applyCallback
      this.cancelCallback = options.cancelCallback

      this.$nextTick(() => {
        this.$refs.clipTab.show()
      })
    },
    clearOptions() {
      this.itemData = null

      this.callbackContext = null
      this.updateCallback = null
      this.actionCallback = null
      this.applyCallback = null
      this.cancelCallback = null
    },
    displayToolPopover(containerEl, editor, displayOptions) {
      this.$refs.popover.displayToolPopover(containerEl, editor, displayOptions)
    },
    viewportUpdated(containerEl, editor) {
    },
    hide() {
      if(this.cancelCallback) {
        // Reset cancel CB so it only is called once when hiding popovers
        let cancelCB = this.cancelCallback
        this.cancelCallback = null

        cancelCB(this.callbackContext, false)
      }

      this.clearOptions()
      this.$refs.popover.hide()
    },
    cancelEditing() {
      if(this.cancelCallback)
        this.cancelCallback(this.callbackContext, true)

      this.clearOptions()
      this.hide()
    },
    onShortcutKey(code) {
      switch(code) {
        case 'Escape':
          this.cancelEditing()
          break
      }
    },
  }
}
</script>